import type { OrganizationTreeProps } from "./organization-tree.type";

import { useGetOrganizationTree } from "@/entities/asset-tree";
import ModelTree from "@/modules/model-tree";

const OrganizationTree = ({
  organizationId,
  ...options
}: OrganizationTreeProps) => {
  const { tree, isLoading } = useGetOrganizationTree(organizationId);

  return <ModelTree nodes={tree} loading={isLoading} {...options} />;
};

export default OrganizationTree;
